"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlural = isPlural;
const nonPluralNounsEndingInS = new Set([
    'address',
    'athletics',
    'billiards',
    'bowels',
    'business',
    'chaos',
    'chess',
    'crossroads',
    'economics',
    'ethics',
    'gallows',
    'gas',
    'genetics',
    'glass',
    'grass',
    'gymnastics',
    'happiness',
    'kindness',
    'linguistics',
    'loneliness',
    'mathematics',
    'measles',
    'minus',
    'mumps',
    'news',
    'physics',
    'progress',
    'success',
    'tennis',
    'acoustics',
    'aerobics',
    'aerodynamics',
    'aeronautics',
    'classics',
    'electronics',
    'logistics',
    'mechanics',
    'obstetrics',
    'politics',
    'statistics',
    'thermodynamics',
    'bowls',
    'cards',
    'darts',
    'diabetes',
    'rabies',
    'draughts',
    'skittles',
    'rickets',
    'shingles',
    'iris',
    'lens',
    'status',
]);
const pluralNounsNotEndingInS = new Set([
    'feet',
    'teeth',
    'geese',
    'men',
    'women',
    'mice',
    'dice',
    'oxen',
    'children',
    'people',
    'pence',
    'foci',
    'radii',
    'fungi',
    'nuclei',
    'cacti',
    'alumni',
    'phenomena',
    'criteria',
    'data',
    'memoranda',
    'bacteria',
    'strata',
    'curricula',
    'media',
    'stadia',
    'syllabi',
    'antennae',
    'lice',
    'genera',
    'stimuli',
]);
function isPlural(noun) {
    const term = noun.toLowerCase();
    return (!nonPluralNounsEndingInS.has(term) &&
        !term.endsWith('itis') &&
        !term.endsWith('osis') &&
        (term.endsWith('s') || pluralNounsNotEndingInS.has(term)));
}
//# sourceMappingURL=data:application/json;base64,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